module.exports = __webpack_public_path__ + "static/img/客户墙00021.4b69679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/客户墙00021.png
// module id = 9f0Y
// module chunks = 1